const WIDGET_SRC =
    'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'

/**
 * Loaded after hydration, not from the head: the bootstrap rewrites `.trustpilot-widget` elements React renders,
 * and doing that before hydration makes React 18 discard the server HTML. See gatsby-ssr.js.
 */
exports.onInitialClientRender = () => {
    if (document.querySelector(`script[src="${WIDGET_SRC}"]`)) return

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = WIDGET_SRC
    script.async = true
    document.head.appendChild(script)
}
